interface HighlightTextProps {
  text: string
  query: string | undefined
}

export const HighlightText = ({ text, query }: HighlightTextProps) => {
  if (!query || !text) return <>{text}</>

  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const parts = text.split(new RegExp(`(${escaped})`, 'gi'))

  if (parts.length === 1) return <>{text}</>

  return (
    <>
      {parts.map((part, i) => {
        const key = `${part}-${i}`
        return part.toLowerCase() === query.toLowerCase() ? (
          <mark key={key} className="bg-yellow-200 text-inherit rounded-sm">
            {part}
          </mark>
        ) : (
          <span key={key}>{part}</span>
        )
      })}
    </>
  )
}
